'use client'

import dynamic from 'next/dynamic'

/**
 * Wilson's office on the contact page — Asana 024 (Steve 2026-09-01).
 *
 * The slot held a plain `bg-muted` square with a comment saying to swap it for a
 * real map once a Google Maps key existed. It does now, so this fills it using
 * the same PropertyMap the listing pages use: muted Wilson-grey styling and the
 * brand teardrop pin, so it reads as part of the site rather than a stock embed.
 *
 * Client-only for the same reason as SidebarMap — the Google Maps SDK touches
 * `window`, so it must not render on the server.
 */
const PropertyMapLazy = dynamic(
  () => import('@/components/listings/PropertyMap').then((mod) => ({ default: mod.PropertyMap })),
  {
    ssr: false,
    loading: () => <div className="aspect-square w-full bg-muted" aria-hidden="true" />,
  },
)

/** Ground Floor, 62 Church St, Traralgon VIC 3844. */
const OFFICE = { lat: -38.1936592, lng: 146.5359332 }

export function OfficeMap() {
  return (
    <div
      className="aspect-square w-full overflow-hidden"
      role="img"
      aria-label="Map showing Wilson Property’s office at Ground Floor, 62 Church Street, Traralgon"
    >
      <PropertyMapLazy
        lat={OFFICE.lat}
        lng={OFFICE.lng}
        className="relative z-0 h-full w-full overflow-hidden"
      />
    </div>
  )
}
